import { fetchMeUseQuery } from '@api/useQueryCalls';
import { useNavigation } from '@react-navigation/native';
import { getStore } from '@store/storeUtils';
import React, { useEffect } from 'react';
import { autoLoginIfCorrectTokens, renderHomePageOnAutoLogin } from './accessFromPartnerUtils';

const AccessFromPartner: React.FC = () => {
  const navigation = useNavigation();
  const {
    setAccounts,
    setCanShowReferral,
    setEmployeeId,
    setIsInLockPeriod,
    setReferralApplicable,
    setStatus,
    setUserId,
    setSelectedAccount,
    setEmployerId,
    setBPAccounts,
    setSelectedBPAccounts,
    setLoginData,
    setBPPhone,
    setIsSuspended,
    setOtpData,
    setHeaderText,
    setReferralHeaderText,
    setAppliedReferral,
    setTxnSuccessReferral,
    setMeAmplitudeContext,
    setAutoDisburseData,
  } = getStore();

  const { isSuccess, data: meApiData, refetch } = fetchMeUseQuery();

  const checkToken = async (): Promise<void> => {
    const { search } = window.location;
    await autoLoginIfCorrectTokens(search, refetch);
  };

  useEffect(() => {
    checkToken();
  }, []);

  useEffect(() => {
    renderHomePageOnAutoLogin(
      isSuccess,
      meApiData,
      setLoginData,
      setAccounts,
      setSelectedAccount,
      setCanShowReferral,
      setEmployeeId,
      setIsInLockPeriod,
      setReferralApplicable,
      setStatus,
      setUserId,
      setEmployerId,
      setBPAccounts,
      setSelectedBPAccounts,
      setBPPhone,
      setIsSuspended,
      setOtpData,
      setHeaderText,
      setReferralHeaderText,
      setAppliedReferral,
      setTxnSuccessReferral,
      setMeAmplitudeContext,
      setAutoDisburseData,
      navigation,
    );
  }, [meApiData, isSuccess, navigation]);

  return null;
};

export default AccessFromPartner;
